import type { TypesenseSearchLocale } from '../../types/typesense';

const ALGOLIA_INDEX_TO_LOCALE: Record<string, TypesenseSearchLocale> = {
  en_search: 'en',
  fi_hae: 'fi',
  sv_sok: 'sv',
};

const LOCALE_TO_COLLECTION: Record<TypesenseSearchLocale, `jobs_${TypesenseSearchLocale}`> = {
  en: 'jobs_en',
  fi: 'jobs_fi',
  sv: 'jobs_sv',
};

export function localeFromAlgoliaJobsIndex(indexName: string): TypesenseSearchLocale | null {
  const base = indexName.replace(/_postedDate_desc$/, '').replace(/_salaryRangeMin_desc$/, '');
  return ALGOLIA_INDEX_TO_LOCALE[base] ?? null;
}

export function getTypesenseJobsCollectionForLocale(locale: TypesenseSearchLocale): `jobs_${TypesenseSearchLocale}` {
  return LOCALE_TO_COLLECTION[locale];
}

export function getTypesenseJobsCollectionForAlgoliaIndex(indexName: string): `jobs_${TypesenseSearchLocale}` | null {
  const locale = localeFromAlgoliaJobsIndex(indexName);
  if (!locale) return null;
  return getTypesenseJobsCollectionForLocale(locale);
}

export function parseSortFromAlgoliaIndex(indexName: string): 'relevance' | 'date' | 'salary' {
  if (indexName.endsWith('_postedDate_desc')) return 'date';
  if (indexName.endsWith('_salaryRangeMin_desc')) return 'salary';
  return 'relevance';
}

export function buildTypesenseSortBy(sort: 'relevance' | 'date' | 'salary'): string | undefined {
  if (sort === 'date') return 'postedDate:desc';
  if (sort === 'salary') return 'salaryRangeMin:desc';
  return undefined;
}
